export default __webpack_public_path__ + "bd16014fffc563f62179407309cf978f.mp3";